import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-3">
              Categories
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              Shop by Category
            </h2>
          </div>
          <p className="mt-3 md:mt-0 text-sm text-foreground-500 max-w-md">
            14 curated collections for your research workflow &mdash; explore everything from footwear to accessories
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full aspect-[4/5] overflow-hidden bg-background-100">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    View
                  </span>
                </div>
              </div>
              {/* Info */}
              <div className="p-3 md:p-4">
                <h3 className="font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-500">
                  {cat.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}